import clearSearchScope from '../actions/clearSearchScope';
import setStaticSearchScope from '../actions/setStaticSearchScope';
import { SearchScenarioId } from 'owa-search-next';
import { startSearch } from 'owa-search-next-lazy';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { orchestrator } from 'satcheljs';
import {
    primaryMailboxSearchScope,
    archiveMailboxSearchScope,
    SearchScopeKind,
} from 'owa-search-service';
import {
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
} from 'owa-folders';

export default orchestrator(clearSearchScope, actionMessage => {
    // Change scope to "All folders".
    if (actionMessage.searchScopeKind == SearchScopeKind.PrimaryMailbox) {
        setStaticSearchScope(
            primaryMailboxSearchScope({
                folderId: folderNameToId(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID),
                kind: SearchScopeKind.PrimaryMailbox,
            })
        );
    } else if (actionMessage.searchScopeKind == SearchScopeKind.ArchiveMailbox) {
        setStaticSearchScope(
            archiveMailboxSearchScope({
                folderId: folderNameToId(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID),
                kind: SearchScopeKind.ArchiveMailbox,
            })
        );
    }

    // Kick off search (if actionMessage says to).
    if (actionMessage.shouldStartSearch) {
        startSearch(actionMessage.actionSource, SearchScenarioId.Mail, false /* explicitSearch */);
    }
});
